import { Component, ElementRef, ViewChild } from '@angular/core';
import { RoutecrumpsService } from '../services/routecrumps.service';
import { Router } from '@angular/router';
import { HomeLandingService } from './home-landing.service';
import { DatePipe } from '@angular/common';
import { SharedService } from '../services/shared.service';
import * as d3 from 'd3';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LogsearchvarService } from '../log-search/services/logsearchvar.service';


@Component({
  selector: 'app-home-landing',
  templateUrl: './home-landing.component.html',
  styleUrls: ['./home-landing.component.scss']
})
export class HomeLandingComponent {

  constructor(
    private rcrumpService: RoutecrumpsService,
    private router:Router,
    public homeLanderService: HomeLandingService,
    private datePipe:DatePipe,
    public sharedService:SharedService,
    public logVarService : LogsearchvarService
  ) { }


  default_apidata={
    "data_ingested": {
      "previous": 0,
      "yesterday": 0
    },
    "active_alerts": {
      "previous": 0,
      "yesterday": 0
    },
    "silence_sources": {
      "yesterday": 0
    },
    "avg_eps": {
      "previous": 0,
      "yesterday": 0
    }
  }

  apidata={}

  metadata={
    "homeStats": {
      "trend_colors": {
        "up": "#2f8400",
        "down": "#e02200",
        "neutral": "#6a7282"
      },
      "stats": [
        {
          "disp": "DATA INGESTED",
          "value": "data_ingested",
          "diff_unit": "percentage",
          "metric_type": "trend",
          "desc": "Total TB/day",
          "icon": "storage",
          "color": "#0079b8",
          "bg_color": "#eef7fc"
        },
        {
          "disp": "ACTIVE ALERTS",
          "value": "active_alerts",
          "diff_unit": "count",
          "metric_type": "trend",
          "desc": "Total Count",
          "icon": "notifications_active",
          "color": "#2f8400",
          "bg_color": "#fff5f5"
        },
        {
          "disp": "SILENT SOURCES",
          "value": "silence_sources",
          "diff_unit": "count",
          "metric_type": "action_count",
          "desc": "Requires Action",
          "icon": "sensors_off",
          "icon_type": "check_circle_outline",
          "icon_color": "#6a7282",
          "color": "#eb8d00",
          "bg_color": "#fffcf0"
        },
        {
          "disp": "AVG EPS",
          "value": "avg_eps",
          "diff_unit": "count",
          "metric_type": "trend",
          "desc": "Event Ingestion",
          "icon": "speed",
          "color": "#0079b8",
          "bg_color": "#eef7fc"
        }
      ]
    }
  }

  @ViewChild('statsWrapper', { static: true })
  statsWrapper!: ElementRef<HTMLDivElement>;

  applist = this.rcrumpService.applist;

  menu =this.sharedService.menu

  stats=this.homeLanderService.stats
  destroy$: Subject<boolean> = new Subject()

  mat_dashboard_spinner = false
  mat_search_spinner = false
  mat_stats_spinner = false

  dashboardList=[]
  historyList

  ngOnInit(){

    

    this.refreshClick()
    // this.refreshDashboards()
    // this.refreshHistory()
    // console.log(this.applist)
    // this.homeLanderService.todayDate =this.datePipe.transform(Date.now(),'MMM d, yyyy, h:mm:ss a')
    // this.sharedService.sidebarState(true)
    this.crumpReset()
    this.homeLanderService.userName = this.sharedService.userFName +" " + this.sharedService.userLName
  }

  ngAfterViewInit(){
    
    // this.renderStats();
    // this.homeLanderService.stats = this.sharedService?.metaData?.apps?.sensor_metadata?.homeStats
    // this.stats = this.sharedService?.metaData?.apps?.sensor_metadata?.homeStats
    this.sharedService.menu = this.sharedService?.metaData?.apps?.sensor_metadata?.menuList
    this.menu = this.sharedService?.metaData?.apps?.sensor_metadata?.menuList
    // console.log(this.stats)
// console.log(this.menu)

    let newStats = this.buildHomeStats(this.default_apidata,this.metadata)
    // console.log(newStats)
    this.stats = newStats
  }

  buildHomeStats(apiData: any, metadata: any): any[] {
    const homeStats = metadata?.homeStats;
  
    if (!homeStats?.stats || !apiData) {
      return [];
    }
  
    const trendColors = homeStats.trend_colors || {};
  
    const trendIcons: Record<string, string> = {
      up: 'trending_up',
      down: 'trending_down',
      // neutral: 'check_circle_outline'
      neutral: 'trending_flat'
    };
  
    return homeStats.stats
      .map((config: any) => {
        const data = apiData[config.value];
  
        if (!data) {
          return null;
        }
  
        const result: any = {
          disp: config.disp,
          value: config.value,
          stat: String(data.yesterday),
          icon: config.icon,
          desc: config.desc,
          color: config.color,
          bg_color: config.bg_color
        };
  
        if (config.metric_type === 'trend') {
          const previous = Number(data.previous);
          const current = Number(data.yesterday);
  
          const difference = current - previous;
  
          const trend =
            difference > 0
              ? 'up'
              : difference < 0
                ? 'down'
                : 'neutral';
  
          let diff: string;
  
          if (config.diff_unit === 'percentage') {
            const percentage =
              previous !== 0
                ? (difference / previous) * 100
                : 0;
  
            const rounded =
              Number.isInteger(percentage)
                ? percentage
                : Number(percentage.toFixed(2));
  
            diff =
              trend === 'up'
                ? `+${rounded}%`
                : trend === 'down'
                  ? `-${Math.abs(rounded)}%`
                  : '0%';
          } else {
            diff =
              trend === 'up'
                ? `+${Math.abs(difference)}`
                : trend === 'down'
                  ? `-${Math.abs(difference)}`
                  : '0';
          }
  
          result.icon_type = trendIcons[trend];
          result.diff = diff;
          result.icon_color = trendColors[trend];
        } else {
          // Temporary handling for non-trend metrics
          result.diff = '0';
  
          if (config.icon_type) {
            result.icon_type = config.icon_type;
          }
  
          if (config.icon_color) {
            result.icon_color = config.icon_color;
          }
        }
  
        return result;
      })
      .filter((item: any) => item !== null);
  }

  refreshStats(){
    this.mat_stats_spinner=true
    this.homeLanderService.provideStats.postrequest({"user_name":this.sharedService.userName}).pipe(takeUntil(this.destroy$))
    .subscribe((dat: any) => {
      this.apidata = dat
// console.log(this.apidata)
      this.homeLanderService.stats= this.buildHomeStats(this.apidata,this.metadata)
      this.stats=this.buildHomeStats(this.apidata,this.metadata)
      this.mat_stats_spinner =false
    },(err) => {
      this.homeLanderService.stats= this.buildHomeStats(this.default_apidata,this.metadata)
      this.stats=this.buildHomeStats(this.default_apidata,this.metadata)
      this.mat_stats_spinner =false
    })
  }

  refreshDashboards(){
    this.mat_dashboard_spinner=true
    this.homeLanderService.providedashboardlist.postrequest({ metakey: "all" }).pipe(takeUntil(this.destroy$))
    .subscribe((dat: any) => {
      this.dashboardList=dat
//console.log(this.dashboardList)
      this.mat_dashboard_spinner =false
    },(err) => {
      this.mat_dashboard_spinner =false
    })
  }

  refreshHistory(){
    this.mat_search_spinner=true
    this.homeLanderService.getSearchHistory.postrequest({"userName":this.sharedService.userName}).pipe(takeUntil(this.destroy$))
    .subscribe((dat: any) => {
      this.historyList=dat
//console.log(this.historyList)
      this.mat_search_spinner =false
    },(err) => {
      this.mat_search_spinner =false
    })
  }

  private renderStats(): void {

    const trends = ['+12%', '+48', '0', '-2'];

    const trendText = [
        'Total TB/day',
        'Total Count',
        'Requires Action',
        'Event Ingestion'
    ];

    const trendColor = [
        '#16A34A',
        '#EF4444',
        '#6B7280',
        '#EF4444'
    ];

    const container = d3.select(this.statsWrapper.nativeElement);

    // ---------------- CARD ----------------

    const cards = container
        .selectAll<HTMLDivElement, any>('.stat-container')
        .data(this.stats)
        .join('div')
        .attr('class', 'stat-container border-light white-bg p-3 radius-s')
        .style('flex', '1')
        .style('display', 'flex')
        .style('flex-direction', 'column')
        .style('gap', 'var(--spacing3)');

    // ---------------- TOP ROW ----------------

    const topRow = cards
        .selectAll<HTMLDivElement, any>('div.top-row')
        .data(d => [d])
        .join('div')
        .attr('class', 'top-row')
        .style('display', 'flex')
        .style('justify-content', 'space-between')
        .style('align-items', 'center');

    // ---------------- LEFT ----------------

    const left = topRow
        .selectAll<HTMLDivElement, any>('div.left')
        .data(d => [d])
        .join('div')
        .attr('class', 'left')
        .style('display', 'flex')
        .style('flex-direction', 'column')
        .style('gap', 'var(--spacing2)');

    left
        .selectAll<HTMLParagraphElement, any>('p.stat-label')
        .data(d => [d])
        .join('p')
        .attr('class', 'stat-label content-s primary-text')
        .text(d => d.disp);

    left
        .selectAll<HTMLHeadingElement, any>('h2.stat-value')
        .data(d => [d])
        .join('h2')
        .attr('class', 'stat-value primary-text lighter-text')
        .text(d => d.stat);

    // ---------------- RIGHT ICON ----------------

    const iconBox = topRow
        .selectAll<HTMLDivElement, any>('div.icon-box')
        .data(d => [d])
        .join('div')
        .attr('class', 'icon-box')
        .style('width', '48px')
        .style('height', '48px')
        .style('display', 'flex')
        .style('justify-content', 'center')
        .style('align-items', 'center')
        .style('border', '1px solid #B6E3FF')
        .style('border-radius', '4px')
        .style('background', '#F2FAFF');

    iconBox
        .selectAll('mat-icon')
        .data(d => [d])
        .join('mat-icon')
        .attr('class', d => `${d.icon_type} stat-icon mat-icon`)
        .style('font-size', '28px')
        .style('color', '#0B82C8')
        .text(d => d.icon);

    // ---------------- FOOTER ----------------

    const footer = cards
        .selectAll<HTMLDivElement, any>('div.stat-footer')
        .data((d, i) => [{
            trend: trends[i],
            text: trendText[i],
            color: trendColor[i]
        }])
        .join('div')
        .attr('class', 'stat-footer')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('gap', 'var(--spacing2)')
        .style('margin-top', 'auto');

    // ---------------- TREND ICON ----------------

    footer
        .selectAll('span.trend-icon')
        .data(d => [d])
        .join('span')
        .attr('class', 'material-symbols-outlined trend-icon')
        .style('font-size', '18px')
        .style('color', d => d.color)
        .text('trending_up');

    // ---------------- TREND VALUE ----------------

    footer
        .selectAll<HTMLSpanElement, any>('span.trend-value')
        .data(d => [d])
        .join('span')
        .attr('class', 'trend-value content-s')
        .style('font-weight', '600')
        .style('color', d => d.color)
        .text(d => d.trend);

    // ---------------- FOOTER TEXT ----------------

    footer
        .selectAll<HTMLSpanElement, any>('span.trend-text')
        .data(d => [d])
        .join('span')
        .attr('class', 'trend-text content-s light-text')
        .text(d => d.text);
}

  crumpReset(){
    this.rcrumpService.homeIcon.isSelected = true
    this.rcrumpService.route_crumps[0] = {
      disp_str: "Home",
      routeTo: "home",
      callback: null,
      isParent: false
    }
    this.rcrumpService.route_crumps.length = 1;
    this.rcrumpService.resetMenuList()

    this.sharedService.menu?.forEach(key=>{
      key.list.forEach(items=>{
          items.isSelected = false
      })
    })
  }

  optionClick(nav,event){

    if(nav.isSelectable){
      this.rcrumpService.homeIcon.isSelected=false

      this.router.navigateByUrl(nav.url)
      this.sharedService.menu.forEach(key=>{
        key.list.forEach(items=>{
          if(items.value != nav.value){
            items.isSelected = false
          }else{
            items.isSelected = true
          }
        })
      })
    }else{
      event.stopPropagation()
    }

    
  }

  sidebarClick(){
    this.sharedService.sidebarState(true)
  }

  tabClick(tab){
    this.homeLanderService.selectedTab = tab
//console.log(this.homeLanderService.selectedTab)
  }

  dashboardOptionClick(option,dashboard,origin?){

    //console.log(option, dashboard)
        if (option == 'edit' || option == 'preview'){

          this.homeLanderService.dashboardGet({"dashboard_id":dashboard.dashboard_id})
            .pipe(takeUntil(this.destroy$))
            .subscribe((val) => {
              this.mat_dashboard_spinner = false;
    //console.log('===dashboard_info===',val);
    this.rcrumpService.homeIcon.isSelected=false
    this.sharedService.menu.forEach(key=>{
      key.list.forEach(items=>{
        if(items.value != "studio"){
          items.isSelected = false
        }else{
          items.isSelected = true
        }
      })
    })
                if(option == 'preview'){
                  this.previewDashboard(val['grid_options'],val['dashboard_name'])
                } 
                
            },
              (err) => {
                this.mat_dashboard_spinner  = false;
              });
        }
      }

  previewDashboard(gridOptions,dbname){
    this.router.navigate(['dashboard-preview'], {
      state: {
        data: gridOptions,
        dbname: dbname,
        home:true
      }
    });
  }

  historyClick(history){
    // console.log("TabsList =----> ",this.logVarService.tabsList)
    // console.log(this.sharedService.metaData)
    let notepad_collectionObj = JSON.parse(JSON.stringify(this.sharedService.metaData.logsearch.log_search_defaults.search_notebook))
    notepad_collectionObj[0]["partitions"]=history.partitions
    notepad_collectionObj[0]["sqlquery"]=history.search
    notepad_collectionObj[0]["accordianRequest"]=[]
    let tabObj={"name":"untitled","created_by":this.homeLanderService.userName,"savedTime":history.created_dt,"userList":[],"visibility":"public","notepadCollection":notepad_collectionObj,"mode":"recent"}
    this.logVarService.tabsList.push(tabObj)
    // this.logVarService.tabsList.push(this.sharedService.metaData.logsearch.log_search_defaults.search_notebook[0])
    this.rcrumpService.homeIcon.isSelected=false
    this.sharedService.menu.forEach(key=>{
      key.list.forEach(items=>{
        if(items.value != "search"){
          items.isSelected = false
        }else{
          items.isSelected = true
        }
      })
    })
    this.router.navigateByUrl('log-search')
    this.logVarService.logSelectedIndex=this.logVarService.tabsList.length+2
    
  }
  refreshClick(){
    this.refreshDashboards()
    this.refreshHistory()
    this.refreshStats()
    this.homeLanderService.todayDate =this.datePipe.transform(Date.now(),'MMM d, yyyy, h:mm:ss a')
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
